import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";
import SignUp from "../containers/login/signup";
import Dashboard from "../containers/dashboard/dashboard";
import history from '../services/history.service';
import CustomerList from '../modules/customer/CustomerList'
import CustomerMerge from '../modules/customer/CustomerMerge'
import Settings from '../modules/settings/SettingUpdate'
import AddPaymentLink from '../modules/payment/AddPaymentLink'
import PaymentTerms from "../modules/payment/PaymentTerms";
import EditUniqueID from "../modules/customer/EditUniqueID";
import EmailDomainChange from "../modules/email/EmailDomainChange";
import TicketList from "../modules/ticket/TicketList";
import InvoiceList from "../modules/invoice/InvoiceList";
import EstimateList from "../modules/estimate/EstimateList";
import EstimateRejectionReasons from "../modules/estimate/EstimateRejectionReasons";
import {ThemeProvider} from '@material-ui/core/styles'
import {THEME} from '../common/theme'
import Activity from "../modules/activity/activity";
import RedisCacheList from "../modules/rebuildcache/RebuildRedisCache";
import TriggerAnnouncementList from "../modules/announcements/TriggerAnnouncement";
import ESIndexList from "../modules/rebuildcache/ESIndex";
import DeleteList from "../modules/delete/Delete";
import MoveList from "../modules/move/Move";
import QBSyncList from "../modules/qb_sync/QBSync";
import RegisterCompanyList from "../modules/registerCompany/RegisterCompany";
import FeatureSettings from "../modules/settings/FeatureSettings";
import CustomAssignmentStatus from "../modules/settings/CustomAssignmentStatus";
import FPForms from "../modules/fpforms/FPForms";
import RenewalReminderBanner from "../modules/rrb/RenewalReminderBanner";
import FeatureEnable from "../modules/feature-enable/FeatureUpdate";
import UserList from '../modules/user/UserList';
import RoleList from '../modules/user/RoleList';
import Upload from '../modules/file-upload/FileUpload';
import NotificationSettings from '../modules/notification/NotificationList';
import ForceLogout from '../modules/force-logout/ForceLogout';
import BannerAnnouncement from '../modules/banner-announcement/BannerAnnouncement';

class Routes extends Component {
    constructor(props: any) {
		super(props);
		this.state = {};
    }
    
    render() {
        return (
            <ThemeProvider theme={THEME}>
                <Router history={history}>
                    <Switch>
                        <Route path="/" exact component={Dashboard} />
                        <Route path="/customers/edit/:id" render={(props) => (
                            <EditUniqueID {...this.props} {...props} />
                        )} />
                        <Route path="/customers/edit" component={CustomerList} />
                        <Route path="/customers" exact component={Dashboard} />
                        <Route path="/customers/merge" component={CustomerMerge} />
                        <Route path="/email" component={EmailDomainChange} />   
                        <Route path="/activity" component={Activity} />
                        <Route path="/settings" component={Settings} />
                        <Route path="/signup" component={SignUp} />
                        <Route path="/payment" exact component={AddPaymentLink} />
                        <Route path="/paymentterms" exact component={PaymentTerms} />
                        <Route path="/rebuildesindex" exact component={ESIndexList}/> 
                        <Route path="/move" exact component={MoveList}/> 
                        <Route path="/featuresettings" exact component={FeatureSettings}/> 
                        <Route path="/delete" exact component={DeleteList}/> 
                        <Route path="/triggerannoucements" exact component={TriggerAnnouncementList} />
                        <Route path="/qbsync" exact component={QBSyncList} />
                        <Route path="/tickets" exact component={TicketList} />
                        <Route path="/invoices" exact component={InvoiceList} />
                        <Route path="/estimates" exact component={EstimateList} />
                        <Route
                            path="/estimate-rejection-reasons"
                            exact
                            component={EstimateRejectionReasons}
                        />
                        <Route path="/rebuildrediscache" exact component={RedisCacheList}/>  
                        <Route path="/register" exact component={RegisterCompanyList}/>  
                        <Route path="/fpforms" exact component={FPForms} />
                        <Route path="/rrb" exact component={RenewalReminderBanner}/>
                        <Route path="/feature/enable" exact component={FeatureEnable}/>
                        <Route path="/user" exact component={UserList}/>
                        <Route path="/role" exact component={RoleList}/>
                        <Route path="/upload" exact component={Upload}/>
                        <Route path="/notification" exact component={NotificationSettings}/>
                        <Route path="/forcelogout" exact component={ForceLogout}/>
                        <Route path="/customassignmentstatus" exact component={CustomAssignmentStatus}/>
                        <Route path="/banner-announcement" exact component={BannerAnnouncement}/>
                    </Switch>
                </Router>
            </ThemeProvider>   
        )
    }
}             

export default Routes;
